import { gateIsOpen, poweredPlateIds } from '../model/power';
import { isSurgeActive } from '../model/surge';
import { exitKey } from '../model/widen-gate';
import { RAINBOW_GATES_ID } from './effects/rainbow-gates';
import { SURGE_ID } from './effects/surge';
/**
 * Module 144 (D6) — the gates a confirm card's power-up would change, by
 * `exitKey`, for the board's pink preview while the card is up.
 *
 * - Master Key: every powered gate that is shut right now — exactly the ones it
 *   opens (`hasClosedPoweredGate`'s test, gate by gate).
 * - Wild Gates: every gate that is open right now (counting a Master Key that is
 *   already open), because any colour may then use any of them.
 *
 * Any other power-up has no card and no preview.
 */
export function confirmPreviewGates(id, state) {
    const powered = poweredPlateIds(state.blocks, state.puzzle.plates);
    const exits = state.puzzle.exits;
    if (id === SURGE_ID) {
        return exits.filter((e) => e.powered && !gateIsOpen(e, powered)).map(exitKey);
    }
    if (id === RAINBOW_GATES_ID) {
        const surge = isSurgeActive(state);
        return exits.filter((e) => gateIsOpen(e, powered, surge)).map(exitKey);
    }
    return [];
}
/** D7 — at most this many "any colour" badges: every open gate would be clutter. */
export const WILD_BADGE_LIMIT = 2;
const WALL_ORDER = ['up', 'right', 'down', 'left'];
/**
 * Module 144 (D7) — which previewed gates get a first-use badge. Master Key:
 * every one (a board has only a few shut gates). Wild Gates: the first
 * `WILD_BADGE_LIMIT` in a fixed order — top, right, bottom, left wall, then
 * along each wall — so the same board always badges the same gates.
 */
export function confirmBadgeGates(id, keys, exits) {
    if (id !== RAINBOW_GATES_ID)
        return [...keys];
    const along = (e) => e.direction === 'up' || e.direction === 'down' ? e.position.col : e.position.row;
    return exits
        .filter((e) => keys.includes(exitKey(e)))
        .sort((a, b) => WALL_ORDER.indexOf(a.direction) - WALL_ORDER.indexOf(b.direction) || along(a) - along(b))
        .slice(0, WILD_BADGE_LIMIT)
        .map(exitKey);
}
